var ListManagerViewType = {
    List: "Standard List View",
    Nup: "Multi-chart View",
    ListAnalytics: "List Analytics",
    QuoteBoard: "Quote Board"
  };
export default ListManagerViewType;
